var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 40,
    viewBox: "0 0 27 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.271 0.328125C10.4341 0.331246 7.71435 1.45949 5.70829 3.46534C3.70223 5.4712 2.57372 8.19087 2.57031 11.0277C2.57031 13.783 4.7038 18.095 8.9118 23.8436C9.41275 24.5299 10.0687 25.0882 10.8262 25.4731C11.5836 25.858 12.4213 26.0586 13.271 26.0586C14.1206 26.0586 14.9583 25.858 15.7158 25.4731C16.4733 25.0882 17.1292 24.5299 17.6301 23.8436C21.8382 18.095 23.9716 13.783 23.9716 11.0277C23.9682 8.19087 22.8397 5.4712 20.8337 3.46534C18.8276 1.45949 16.1078 0.331246 13.271 0.328125ZM13.271 15.2925C12.4228 15.2925 11.5937 15.041 10.8885 14.5698C10.1832 14.0986 9.63358 13.4288 9.309 12.6452C8.98442 11.8616 8.89949 10.9994 9.06496 10.1675C9.23043 9.33563 9.63886 8.57151 10.2386 7.97176C10.8384 7.37202 11.6025 6.96359 12.4343 6.79812C13.2662 6.63265 14.1285 6.71757 14.9121 7.04215C15.6957 7.36673 16.3654 7.91639 16.8367 8.62161C17.3079 9.32684 17.5594 10.156 17.5594 11.0041C17.5594 12.1415 17.1076 13.2323 16.3033 14.0365C15.4991 14.8407 14.4083 15.2925 13.271 15.2925Z",
    fill: "url(#paint0_linear_10822_5192)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_10822_5192)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.271,
    cy: 33.7964,
    rx: 8.94678,
    ry: 1.73779,
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_10822_5192",
    x: 0.324219,
    y: 28.0586,
    width: 25.8936,
    height: 11.4766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_10822_5192"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10822_5192",
    x1: 4.17541,
    y1: 0.328122,
    x2: 26.4659,
    y2: 9.38438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355B85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2E44"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerGoogle);
export default __webpack_public_path__ + "static/media/markerGoogle.01d1dc8031ea78a0eb550b485c400e1e.svg";
export { ForwardRef as ReactComponent };